export default "__VITE_ASSET__CxdxDFsR__"